import {VALUE_TYPE} from "../enums/enums";
import {JP} from "./jp";
import * as _ from "underscore";


class InputUtils {
  getValueModelAndInitializeIfNecessary(document: any,
                                        pointer: string,
                                        valueType: VALUE_TYPE) {
    this.initializePropertyIfNecessary(document, pointer, valueType);

    const value = JP.get(document, pointer);
    if ((valueType === VALUE_TYPE.ARRAY_UINT || valueType === VALUE_TYPE.ARRAY_RATIONAL) && _.isArray(value)) {
      return value.join(",");
    }
    if (valueType === VALUE_TYPE.JSON)
    {
      return JSON.stringify(value, null," ");
    }
    return value;
  }


  initializePropertyIfNecessary(document: any,
                                pointer: string,
                                valueType: VALUE_TYPE) {
    if (!JP.has(document, pointer)) {
      if (valueType === VALUE_TYPE.ARRAY_UINT || valueType === VALUE_TYPE.ARRAY_RATIONAL) {
        JP.set(document, pointer, []);
      } else {
        JP.set(document, pointer, void 0);
      }
    }
  }


  initializeArrayIfMissing(document: any, pointer: string) {
    if (_.isUndefined(document) || _.isUndefined(pointer)) {
      return;
    }

    if (!JP.has(document, pointer) || !_.isArray(JP.get(document, pointer))) {
      JP.set(document, pointer, []);
    }
  }


  initializeObjectIfMissing(document: any, pointer: string) {
    if (_.isUndefined(document) || _.isUndefined(pointer)) {
      return;
    }

    if (!JP.has(document, pointer) || !_.isObject(JP.get(document, pointer))) {
      JP.set(document, pointer, {});
    }
  }
}


export const inputUtils = new InputUtils();



// WEBPACK FOOTER //
// /opt/app/develop/src/app/helpers/input-utils.ts